import * as types from '../actionType'

const initialState = []

const sellerOrderCompleted = (state = initialState, action) => {
    switch (action.type) {
        case types.SELLER_POST_COMPLETED_ORDER:
            return action.payload
        default:
            return state
    }
}


export { sellerOrderCompleted }